// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

export const API_URL = '/api';

export const MY_DOMAIN_SEARCH_URL       = (search: string)                            : string => `/domains?s=${q(search)}`;
export const MY_CLIENT_LIST_API_URL     = ()                                          : string => `/clients`;
export const MY_TASK_LIST_API_URL     = ()                                          : string => `/tasks`;
export const MY_CLIENT_API_URL          = (clientId: string)                          : string => `/clients/${q(clientId)}`;
export const MY_PERMISSION_LIST_API_URL = ()                          : string => `/permissions`;
export const MY_CLIENT_PERMISSION_LIST_API_URL = (clientId: string)                          : string => `/clients/${q(clientId)}/permissions`;
export const MY_ORDER_LIST_API_URL      = (clientId: string)                          : string => `/clients/${q(clientId)}/orders`;
export const MY_ORDER_API_URL           = (clientId: string, orderId : string)        : string => `/clients/${q(clientId)}/orders/${q(orderId)}`;
export const MY_INVOICE_LIST_API_URL    = (clientId: string)                          : string => `/clients/${q(clientId)}/invoices`;
export const MY_INVOICE_API_URL         = (clientId: string, invoiceId: string)       : string => `/clients/${q(clientId)}/invoices/${q(invoiceId)}`;
export const MY_INVOICE_CREATE_PAYMENT_TRANSACTION_API_URL = (clientId: string, invoiceId: string) : string => `/clients/${q(clientId)}/invoices/${q(invoiceId)}/payments`;
export const MY_PAYMENT_LIST_API_URL    = (clientId: string)                          : string => `/clients/${q(clientId)}/payments`;
export const MY_PAYMENT_API_URL         = (clientId: string, paymentId : string)      : string => `/clients/${q(clientId)}/payments/${q(paymentId)}`;
export const MY_INVENTORY_LIST_API_URL  = (clientId: string)                          : string => `/clients/${q(clientId)}/inventory`;

export const AGENT_VPS_INVENTORY_LIST_API_URL  = (system?: string, name?:string) : string => `/agent/inventory/vps${ 
    ( system || name ) ? `?${
        [
            ...(system ? [`system=${q(system)}`] : []),
            ...(name ? [`name=${q(name)}`] : []),
        ].join('&')
    }` : ''
}`;

export const AGENT_SHELL_INVENTORY_LIST_API_URL  = (hostname?: string, username?:string) : string => `/agent/inventory/shell${ 
    ( hostname || username ) ? `?${
        [
            ...(hostname ? [`hostname=${q(hostname)}`] : []),
            ...(username ? [`username=${q(username)}`] : []),
        ].join('&')
    }` : ''
}`;

export const AGENT_WEB_INVENTORY_LIST_API_URL  = (system?: string, name?:string) : string => `/agent/inventory/web${ 
    ( system || name ) ? `?${
        [
            ...(system ? [`system=${q(system)}`] : []),
            ...(name ? [`name=${q(name)}`] : []),
        ].join('&')
    }` : ''
}`;

export const AGENT_INVENTORY_ITEM_API_URL = (id: string) : string => `/agent/inventory/item/${ q(id) }`;

export const AGENT_INVENTORY_ITEM_API_UPDATE_URL  = (inventoryItemId: string) : string => `/agent/inventory/item/${q(inventoryItemId)}`;
export const AGENT_INVENTORY_ITEM_API_CREATE_URL  = () : string => `/agent/inventory/item`;

export const MY_INVENTORY_ITEM_API_URL  = (clientId: string, inventoryItemId: string) : string => `/clients/${q(clientId)}/inventory/${q(inventoryItemId)}`;
export const MY_INVENTORY_ITEM_API_UPDATE_URL  = (clientId: string, inventoryItemId: string) : string => `/clients/${q(clientId)}/inventory/${q(inventoryItemId)}`;

function q (value: string) : string {
    return encodeURIComponent(value);
}
